<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserProfile from "@/router/views/users/user-profile"

// Services
import LikesDataService from "@/services/LikesDataService";
import UsersDataService from "@/services/UsersDataService";

// Helpers
import Storage from "@/helpers/storage";
import UserUtils from '@/helpers/users'
import LikesUtils from '@/helpers/likes'
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import AdminUtils from '@/helpers/admin';

// External Components
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';

export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Censored VideoLikes",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    CoolLightBox,
    DatePicker,
    VueTabs,
    VTab,
    UserProfile,
  },

  computed: {
    ...authComputed
  },

  methods: {
    ...UserUtils,
    ...DateUtils,
    ...LikesUtils,

    getRequestParams(page, pageSize) {
      let params = {};
      params["page"] = page - 1;
      params["size"] = pageSize;
      params["filtersGender"] = this.filtersGender.selected;

      if (this.filtersDates.selected === 'custom' && this.filtersDates.dateRange !== null) {
        this.filtersDates.fromDate = this.$moment(this.filtersDates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filtersDates.toDate = this.$moment(this.filtersDates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }

      params["fromDate"] = this.filtersDates.fromDate || '';
      params["toDate"] = this.filtersDates.toDate || '';

      return params;
    },

    handlePageChange(value) {
      this.page = value;
      this.loadVideoLikes();
    },

    handleDisplayChange() {
      this.page = 1;
      this.loadVideoLikes();
    },

    getImage(userId, mediaId, elt) {
      return Storage.getUserMedia(userId, mediaId, elt);
    },

    loadVideoLikes() {
      if (this.isSearching)
        return;

      this.isSearching = true;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected
      );
      if (this.videoLikes.length > 0) {
        this.deleteItems();
        this.imagesCount = 0;
      }

      LikesDataService.getCensoredVideoLikes(params)
        .then(response => {
          const { items, totalItems } = response.data;
          if (items.length > 0) {
            items.forEach(item => {
              item.src = '';
              item.thumb = '';
              item.title =  new Date(item.createdAt).toLocaleString();
              item.description = item.name + ' #'+item.userId;
              item.isVideo = 1;
              this._loadVideoLike(item);
            });
          }
          this.count = totalItems;
          this.isSearching = false;
          //this.$refs.waterfall.waterfallOver();
        })
        .catch(e => {
          this.isSearching = false;
          window.console.error("loadVideoLikes failed...", e);
        })
    },

    _loadVideoLike(item) {

      const promises = [];

      if (item.isVideo) {
        promises.push(Storage.getVideoLikeMediaUrl(item.likerId, item.video));
      }

      const that = this;
      Promise.all(promises)
          .then(values => {
            if (values.length === 1) {
              item.thumb = item.src = values[0];
            } else {
              item.thumb = values[0];
              item.src = values[1];
            }

            let img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function() {
              item.width = img.width;
              item.height = img.height;
              item.imgObj = img;
              that.videoLikes.push(item);
            };
            img.src = item.thumb;
          })
        .catch (error => {
          window.console.error(error);
          let img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = function() {
            item.width = img.width;
            item.height = img.height;
            item.imgObj = img;
            that.videoLikes.push(item);
          };
          img.src = require("@/assets/images/users/error.png");
        });
    },

    mediaClick(value) {
      let mediaId = value.video.replace(".jpg", ".mp4");
      mediaId = mediaId.replace("th_", "");

      Storage.getVideoLikeMediaUrl(value.likerId, mediaId)
          .then((url) => {
            const media = {
              "id": 1,
              "userId": value.likerId,
              "mediaId": mediaId,
              "createdAt": "",
              "typeMedia": 1,
              "src": url,
              "title": "1/1",
            };

            this.showUserMedia([media], 0);
          });
    },

    rendered (mediaId) {
      this.imagesCount++

      let elt = document.getElementById(mediaId).parentNode;
      this.resizeMasonryItem(elt);
    },

    resizeMasonryItem (item) {
      /* Get the grid object, its row-gap, and the size of its implicit rows */
      let grid = document.getElementsByClassName('masonry')[0],
          rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
          rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));

      /*
       * Spanning for any brick = S
       * Grid's row-gap = G
       * Size of grid's implicitly create row-track = R
       * Height of item content = H
       * Net height of the item = H1 = H + G
       * Net height of the implicit row-track = T = G + R
       * S = H1 / T
       */

      let rowSpan = Math.ceil((item.querySelector('.media-item-content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));

      /* Set the spanning as calculated above (S) */
      item.style.gridRowEnd = 'span ' + rowSpan;
    },

    deleteItems() {
      document.querySelectorAll('.media-item').forEach(elt => {
        elt.remove();
      });
      this.videoLikes.splice(0, this.videoLikes.length);
    },

    resizeAllMasonryItems () {
      // Get all item class objects in one list
      let allItems = document.getElementsByClassName('media-item');
      /*
       * Loop through the above list and execute the spanning function to
       * each list-item (i.e. each masonry item)
       */
      for (let i = 0; i < allItems.length; i++) {
        this.resizeMasonryItem(allItems[i]);
      }
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filtersDates.selected) {
        case "always":
          this.filtersDates.fromDate = null;
          this.filtersDates.toDate = null;
          break;
        case "today":
          this.filtersDates.fromDate = now.format('YYYY-MM-DD');
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filtersDates.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filtersDates.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filtersDates.toDate = now.subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filtersDates.toDate = now.format('YYYY-MM-DD');
          this.filtersDates.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filtersDates.fromDate = null;
          this.filtersDates.toDate = null;
          break;
      }
      if (this.filtersDates.selected !== "custom") {
        this.filtersDates.dateRange = null;
        this.loadVideoLikes();
      }
    },

    openUserPane() {
      if (!this.isUserPaneDisplayed) {
        this.isUserPaneDisplayed = true;
      }
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    async showUser(obj) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(user => user.userId === obj.userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        try {
          const result = await UsersDataService.get(obj.userId);
          if (typeof result.data === 'undefined')
            throw new Error('unable to find user '+obj.userId);

          this.userTabs.push(UserUtils.normalize(result.data));
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== obj.userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = obj.userId; }, 100);
      }
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    },

    validVideoLike(videoLike) {
      let parent = document.getElementById(videoLike.documentId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');
      LikesUtils.validVideoLike(videoLike, this.getUser.uid)
      .then(async () => {

        await AdminUtils.addAction({
          adminId: this.getUser.uid,
          category: 'videolikes',
          type: 'valid',
          userId: videoLike.likerId,
          data1: videoLike.documentId
        });
        loadingElt.classList.toggle('d-none');
        this.$toast.success(this.$t('media.media_valid_success'));
        videoLike.isValid = true;
        this.count--;
        let idx = this.videoLikes.findIndex(v => v.documentId === videoLike.documentId);
        if (idx > -1) this.videoLikes.splice(idx, 1);
        this.resizeAllMasonryItems();
      })
      .catch(error => {
        loadingElt.classList.toggle('d-none');
        window.console.error("LikesUtils.validVideoLike", videoLike, error);
        this.$toast.error(error.message);
      })
    },

    deleteVideoLike(videoLike) {
      let parent = document.getElementById(videoLike.documentId);
      let loadingElt = parent.getElementsByClassName('media-item-loading')[0];
      loadingElt.classList.toggle('d-none');
      LikesUtils.deleteVideoLike(videoLike, this.getUser.uid)
        .then(async () => {
          await AdminUtils.addAction({
            adminId: this.getUser.uid,
            category: 'videolikes',
            type: 'delete',
            userId: videoLike.likerId,
            data1: videoLike.documentId
          });
          this.count--;
          loadingElt.classList.toggle('d-none');
          this.$toast.success(this.$t('media.media_delete_success'));
          let idx = this.videoLikes.findIndex(v => v.documentId === videoLike.documentId);
          if (idx > -1) this.videoLikes.splice(idx, 1);
          this.resizeAllMasonryItems();
        })
      .catch(error => {
        loadingElt.classList.toggle('d-none');
        window.console.error("LikesUtils.deleteVideoLike", videoLike, error);
        this.$toast.error(error.message);
      })
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },
  },

  data() {
    return {
      userMedia: {
        media: [],
        index: -1
      },
      isSearching: false,
      videoLikes: [],
      progressUpload: 0,
      indexMedia: null,
      userTabs:[],
      userTabsActive: '',
      isUserPaneDisplayed: false,
      imagesCount: 0,
      page: 1,
      count: 0,
      title: this.$t("menuitems.members.videolikes"),
      pageSizes: {
        options: ['50', '100', '200'],
        selected: '50'
      },
      filtersGender: {
        selected: '',
        options: [
          '', 'M', 'F'
        ]
      },
      filtersDates: {
        dateRange: null,
        selected: 'always',
        fromDate: null,
        toDate: null,
        options: [
          {value:'today', text:this.$t("dates.today")},
          {value:'yesterday', text:this.$t("dates.yesterday")},
          {value:'curMonth', text:this.$t("dates.curMonth")},
          {value:'lastMonth', text:this.$t("dates.lastMonth")},
          {value:'last3Month', text:this.$t("dates.last3Month")},
          {value:'curYear', text:this.$t("dates.curYear")},
          {value:'always', text:this.$t("dates.always")},
          {value:'custom', text:this.$t("dates.custom")}
        ]
      },
    }
  },

  mounted() {
    this.loadVideoLikes();
  },

  created () {
    let masonryEvents = ['load', 'resize'];
    let vm = this
    masonryEvents.forEach(function (event) {
      window.addEventListener(event, vm.resizeAllMasonryItems);
    });
  },

  watch: {
    imagesCount: function () {
      if(this.imagesCount === this.videoLikes.length) {
        this.resizeAllMasonryItems()
      }
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">

      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- filters -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body row">
              <b-form-row>
                <b-select :disabled="isSearching" class="form-select w-auto" v-model="pageSizes.selected" @change="handleDisplayChange">
                  <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
                </b-select>
                <b-select :disabled="isSearching" class="form-select w-auto ms-2" v-model="filtersGender.selected" @change="handleDisplayChange">
                  <option v-for="gender in filtersGender.options" :key="gender" :value="gender">{{ $t('media.filters_gender'+gender) }}</option>
                </b-select>
                <b-form-select
                    :id="'addSinceMedia'"
                    :disabled="isSearching"
                    @change="handleDateChange"
                    v-model="filtersDates.selected"
                    class="form-select d-inline w-auto ms-2"
                    :options="filtersDates.options">
                </b-form-select>
                 <div class="w-auto ms-2" style="min-width:220px;" v-show="this.filtersDates.selected === 'custom'">
                  <date-picker
                      :lang="page.localePicker"
                      :placeholder="this.$t('choose_date_interval')"
                      type="date"
                      :disabled="isSearching"
                      value-type="format"
                      show-week-number
                      v-model="filtersDates.dateRange"
                      @change="loadVideoLikes"
                      range append-to-body ></date-picker>
                </div>

                <div class="status ms-3" v-show="isSearching">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>

              </b-form-row>
            </div>
          </div>
        </div>
      </div>

      <!-- result -->
      <div class="row">
        <div class="col-12">
          <h3 class="mb-3 justify-content-center"><i class="fas fa-images"></i> {{ count }} media</h3>
          <b-pagination
              v-model="page"
              :total-rows="count"
              :per-page="pageSizes.selected"
              first-number
              last-number
              @change="handlePageChange"
              class="mb-3 justify-content-center"
          ></b-pagination>
          <div class="masonry">
            <div v-for="(item, key) in videoLikes"
                 :key="key"
                 class="media-item">
              <div class="media-item-content position-relative" :id="item.documentId">
                <img :src="item.thumb" class="media-thumb" @load="rendered(`${item.documentId}`)" @click="mediaClick(item)" />
                <div class="position-absolute top-0 w-100">
                  <div class="float-end m-1">
                    <span v-if="item.isVideo" class="text-secondary ms-1 d-inline-block rounded-circle shadow p-1 bg-white">
                      <img :src="require('@/assets/images/video-play.svg')" width="20"  />
                    </span>
                  </div>
                  <div
                      class="d-inline-block text-white p-1 rounded font-size-11 m-1"
                      :class="item.sex === 1 ? 'bg-info' : 'bg-female'"
                  >{{ item.name }}<br>{{ item.qrIndex }}
                  </div>

                </div>
                <div class="p-2" :class="!item.isValid ? 'bg-danger' : 'bg-white'">
                  <div class="d-flex justify-content-center mt-1">
                    <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-danger" @click="deleteVideoLike(item)">
                      <b-icon icon="x" scale="1.5"></b-icon>
                    </b-button>
                    <b-button class="rounded-circle ms-2 me-2 bg-white" variant="outline-secondary" @click="showUser({userId: item.likerId, name: item.name})">
                      <b-icon icon="search" scale="1"></b-icon>
                    </b-button>
                    <b-button v-show="!item.isValid" class="rounded-circle ms-2" variant="success" @click="validVideoLike(item)">
                      <b-icon icon="check" scale="1.5"></b-icon>
                    </b-button>
                  </div>
                </div>

                <div class="p-2 bg-light text-center text-muted font-size-10">
                  #<b>{{ item.documentId }}</b>
                </div>
                <div class="media-item-loading d-none"><i class="bx bx-loader-circle bx-spin"></i></div>
              </div>
            </div>
          </div>

          <!-- pagination -->
          <b-pagination
              v-model="page"
              :total-rows="count"
              :per-page="pageSizes.selected"
              first-number
              last-number
              @change="handlePageChange"
              class="mt-3 justify-content-center"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-sidebar
        id="sidebar-right" right
        v-model="isUserPaneDisplayed"
    >
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia"
              >
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>


    <!-- lightshow -->
    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>

  </Layout>
</template>

<style>

  .cursor-pointer {
    cursor:pointer;
  }

  .masonry {
    display: grid;
    grid-gap: 15px;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    grid-auto-rows: 0;
  }

  .bg-female {
    background-color: #f06292;
  }

  .mediaImg {
    max-height: calc(100vh - 100px);
    border-radius: 10px;
    border-top-right-radius-radius:0px;
    border-bottom-right-radius-radius:0px;
  }

  .media-item {
    min-height: 200px
  }

  .media-item-content {
    overflow: hidden;
    border-radius: 5px;
    width: 100%;
    background: #F5F5F5;
    box-shadow: 0 0 10px #999;
  }

  .modalValidLoading {
    position: absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
    background-color: rgba(255, 255, 255, .7);
    border-radius: 10px;
  }

  .modalValidLoading > div {
    position: relative;
    width: 100px;
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translate(-50%, -50%);
  }

  .media-item-loading {
    position: absolute;
    top:0;
    right:0;
    bottom: 0;
    left:0;
    text-align: center;
    background-color: rgba(255, 255, 255, .7);
  }

  .media-item-loading i {
    font-size: 60px;
    margin-top: 100px;
  }

  .media-item-content img.media-thumb {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
  }

  .b-sidebar-right {
    width:35%;
  }

  .b-sidebar-body {
    padding:16px;
  }

</style>
